import { forwardRef } from "react";
import type { EquiplyIconProps, EquiplyIcon } from "../types";

/** Inbox / boîte de réception — bac avec rabat duotone */
export const InboxIcon: EquiplyIcon = forwardRef<SVGSVGElement, EquiplyIconProps>(
  ({ size = 24, ...props }, ref) => (
    <svg ref={ref} width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
      {/* Zone basse menthe */}
      <path d="M3 13l3-1h12l3 1v6.5A1.5 1.5 0 0 1 19.5 21h-15A1.5 1.5 0 0 1 3 19.5V13z" fill="var(--equiply-icon-bg)" fillOpacity="0.55" />
      {/* Contour boîte */}
      <path
        d="M3 13l3-8h12l3 8v6.5A1.5 1.5 0 0 1 19.5 21h-15A1.5 1.5 0 0 1 3 19.5V13z"
        stroke="var(--equiply-icon-fg)" strokeWidth="1.5" strokeLinejoin="round"
      />
      {/* Encoche centrale (zone d'arrivée des messages) */}
      <path
        d="M3 13h5l1 2h6l1-2h5"
        stroke="var(--equiply-icon-fg)" strokeWidth="1.5" strokeLinejoin="round"
      />
    </svg>
  ),
);
InboxIcon.displayName = "InboxIcon";
